import Model, { ID, Integer, IsoDateTime } from 'src/models/model'

export default class UserPoint extends Model {
  static name = 'UserPoint'

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      userId: {
        type: ID,
        default: null
      },
      orderId: {
        type: ID,
        default: null
      },
      orderItemId: {
        type: ID,
        default: null
      },
      state: {
        type: String,
        default: null
      },
      amountEarned: {
        type: Integer,
        default: 0
      },
      amountUsed: {
        type: Integer,
        default: 0
      },
      amountRemaining: {
        type: Integer,
        default: 0
      },
      expiresAt: {
        type: IsoDateTime,
        default: null
      },
      createdAt: {
        type: IsoDateTime,
        default: null
      }
    }
  }
}
